module.exports = __webpack_public_path__ + "img/rules_mouse.1a5828fb.png";